import { create } from 'zustand';

type AuthorizeNetPaymentData = {
    submissionId: string;
    token: string;
    sandbox: boolean;
}

interface AuthorizeContext {
    paymentData: AuthorizeNetPaymentData;
    setPaymentData: (props: AuthorizeNetPaymentData) => void;
}

export const useAuthorizeContext = create<AuthorizeContext>(set => {
    return {
        paymentData: {
            submissionId: '',
            token: '',
            sandbox: true,
        },
        setPaymentData: (props): void => {
            set({ paymentData: { ...props } });
        },
    };
});
